import { Pipe, PipeTransform } from '@angular/core';
import { CollectionNoticeModel } from '@core/models';

@Pipe({
  name: 'cnstatus',
})
export class CnStatusPipe implements PipeTransform {
  transform(value: string, dataItem: CollectionNoticeModel): string {
    let status = value;

    if (dataItem.isExternalConciliation) {
      status += ' Externo';
    }

    return status;
  }
}
